<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';
  import { afterNavigate } from '$app/navigation';

  interface Props {
    screenshotUrl?: string | undefined;
    onclose?: () => void;
  }

  let { screenshotUrl = undefined, onclose }: Props = $props();

  let previewContent: HTMLImageElement = $state();

  afterNavigate(() => {
    onClose();
  });

  const onClose = (): void => {
    onclose?.();
  };

  const handleKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') {
      onClose();
      return;
    }
  };

  const handleMouseUp = (e: MouseEvent): void => {
    previewContent && !previewContent.contains(e.target) && onClose();
  };
</script>

<svelte:window onkeydown={handleKeyDown} onmouseup={handleMouseUp} />

<div class="comp-screenshot-preview">
  <div class="preview-container">
    <img bind:this={previewContent} src={screenshotUrl} alt="Screenshot preview" />
  </div>
  <div class="close">
    <Icon type={IconType.Button} value="icon-x white" onclick={onClose} />
  </div>
</div>

<style>
  .comp-screenshot-preview {
    position: fixed;
    top: 0;
    left: 0;
    padding: 50px;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    overflow: auto;
    z-index: 99999;
  }
  .preview-container {
    width: 100%;
    height: 100%;
  }
  .preview-container img {
    width: 100%;
  }
  .comp-screenshot-preview .close {
    position: absolute;
    top: 24px;
    right: 24px;
  }
</style>
